import React, { useEffect } from 'react';
import InputTextComp from "@components/UI/InputText/Index.jsx";
import { SaveProcesso } from "@services/Processo/Index.jsx";
import { useForm } from 'react-hook-form';
import ButtonComp from "@components/UI/Button/Index.jsx";
import SweetAlert from "@components/Feedback/SweetAlert/Index.jsx";
import SelectOptionComp from '@components/UI/SelectOption/Index.jsx';
import { blockedOptionMessage } from '@utils/Index.jsx';
import { useFetchDataCascade } from '@hooks/api/useFetchDataCascade.js';

const Create = ({ onSave }) => {

    const {
        register,
        handleSubmit,
        reset,
        setValue,
        watch,
    } = useForm({
        defaultValues: {
            ano: null,
            servico: null,
            tipo: null,
            nomeProcesso: "",
            descricao: "",
        },
    });

    const {
        yearOptions,
        serviceOptions,
        typeOptions,
        yearLoading,
        serviceLoading,
        typeLoading,
        fetchYears,
        fetchServicesByYear,
        fetchTypesByServiceId,
        setServiceOptions,
        setTypeOptions,
        setProcessOptions,
    } = useFetchDataCascade();

    const onSubmit = async (data) => {
        try {
            SweetAlert.loading();

            const payload = {
                idTipoServicoAssociado: data?.tipo?.value,
                nomeProcesso: data?.nomeProcesso,
                descricao: data.descricao,
                flgStatus: true,
            };

            const result = await SaveProcesso(payload);

            SweetAlert.success('Cadastro Realizado!', 'Os dados foram salvos com sucesso.');

            onSave({ ...result });

            reset({
                ano: null,
                servico: null,
                tipo: null,
                nomeProcesso: "",
                descricao: "",
            });

        } catch (error) {

            const errorMessage = error.parsed?.message || 'Não foi possível salvar o processo.';

            SweetAlert.errorHTML('Erro ao cadastrar', errorMessage);
            console.error(error);
        }
    };

    const ano = watch("ano");
    const servico = watch("servico");
    const tipo = watch("tipo");
    const nomeProcesso = watch("nomeProcesso");

    useEffect(() => {
        fetchYears();
    }, []);

    useEffect(() => {
        const selectedYear = ano?.value;

        if (selectedYear) {
            setValue("servico", null);
            setValue("tipo", null);
            setValue("nomeProcesso", "");
            setValue("descricao", "");
            fetchServicesByYear(selectedYear);
        } else {
            setServiceOptions([]);
            setTypeOptions([]);
            setProcessOptions([]);
            setValue("servico", null);
            setValue("tipo", null);
            setValue("nomeProcesso", "");
            setValue("descricao", "");
        }
    }, [ano]);

    useEffect(() => {
        const selectedServiceId = servico?.value;

        if (selectedServiceId) {
            setValue("tipo", null);
            setValue("nomeProcesso", "");
            setValue("descricao", "");
            fetchTypesByServiceId(selectedServiceId);
        } else {
            setTypeOptions([]);
            setProcessOptions([]);
            setValue("tipo", null);
            setValue("nomeProcesso", "");
            setValue("descricao", "");
        }
    }, [servico]);

    useEffect(() => {
        if (!tipo) {
            setValue("nomeProcesso", "");
            setValue("descricao", "");
        } else {
            setValue("nomeProcesso", "");
            setValue("descricao", "");
        }
    }, [tipo]);

    useEffect(() => {
        if (!nomeProcesso) {
            setValue("descricao", "");
        }
    }, [nomeProcesso]);

    return (
        <form onSubmit={handleSubmit(onSubmit)} className='form'>
            <div className="row">

                <div className="p-3">
                    <h3> - Observação: Os campos serão habilitados conforme o preenchimento do atual campo habilitado. </h3>
                </div>

                <div className="col-5 col-md-5">

                    <SelectOptionComp
                        label="Ano"
                        options={yearOptions}
                        value={watch("ano")}
                        onChange={(selected) => setValue("ano", selected)}
                        placeholder="Selecionar um ano"
                        hoverMessage="Selecionar um ano"
                        isLoading={yearLoading}
                        required
                    />
                </div>

                <div className="col-8 col-md-8">

                    <SelectOptionComp
                        label="Serviço"
                        options={serviceOptions}
                        value={watch("servico")}
                        onChange={(selected) => setValue("servico", selected)}
                        placeholder={watch("ano") ? "Selecionar um serviço" : blockedOptionMessage}
                        hoverMessage="Selecionar um serviço"
                        isDisabled={!watch("ano")}
                        isLoading={serviceLoading}
                        required
                    />

                    <SelectOptionComp
                        label="Tipo"
                        options={typeOptions}
                        value={watch("tipo")}
                        onChange={(selected) => setValue("tipo", selected)}
                        placeholder={watch("servico") ? "Selecionar um tipo" : blockedOptionMessage}
                        hoverMessage="Selecionar um tipo"
                        isDisabled={!watch("servico")}
                        isLoading={typeLoading}
                        required
                    />

                    <InputTextComp
                        label="Processo"
                        name="nomeProcesso"
                        {...register("nomeProcesso")}
                        placeholder={watch("tipo") ? "Preencher com um processo" : blockedOptionMessage}
                        hoverMessage="Preencher com um processo"
                        maxLength={255}
                        disabled={!watch("tipo")}
                        required={true}
                    />

                    <InputTextComp
                        label="Descrição"
                        name="descricao"
                        {...register("descricao")}
                        placeholder={watch("nomeProcesso") ? "Preencher com uma descrição" : blockedOptionMessage}
                        hoverMessage="Preencher com uma descrição"
                        maxLength={255}
                        disabled={!watch("nomeProcesso")}
                        required={true}
                    />
                </div>

                <div className="col-md-8 mt-4">
                    <ButtonComp
                        title="SALVAR"
                        type="submit"
                        buttonColor="#2b97be"
                        classnameIcon="fa-regular fa-floppy-disk"
                        hoverMessage={"Botão para confirmar o cadastro"}
                    />
                </div>
            </div>
        </form>
    );
};

export default Create;
